module.exports = __webpack_public_path__ + "static/hifi5-03b73bd4bba7f75f841c35e5ed8a6e7b.jpg";